<template>
  <div class="body-container">
    <div v-if="!msisdnSubmitted">
      <div class="flex-wrap text-center text-box p-3">
        <span class="text-content"><strong>Join Zed Games today and WIN your share of 50GB!</strong></span>
      </div>

      <div class="d-flex flex-column align-items-center text-center">
        <div class="choose-package-text">
          Please choose your package:
        </div>
        <div class="d-flex flex-column activate-buttons-container col-8">
          <button  @click="onJoinNowClicked(currencyOne)" class="activate-button">
            Activate
            <div class="d-flex flex-row justify-content-center">
              <div class="currency-text">{{currencyOne[0]}}</div>
              <div>/{{currencyOne[1]}}</div>
            </div>
          </button>
          <button  @click="onJoinNowClicked(currencyTwo)" class="activate-button">
            Activate
            <div class="d-flex flex-row justify-content-center">
              <div class="currency-text">{{currencyTwo[0]}}</div>
              <div>/{{currencyTwo[1]}}</div>
            </div>
          </button>
          <button  @click="onJoinNowClicked(currencyThree)" class="activate-button">
            Activate
            <div class="d-flex flex-row justify-content-center">
              <div class="currency-text">{{currencyThree[0]}}</div>
              <div>/{{currencyThree[1]}}</div>
            </div>
          </button>
        </div>
      </div>

    </div>

    <div v-if="msisdnSubmitted">
      <div class="d-flex col justify-content-center pt-1" v-if="(!errorMessage&&!subscribeError)">
        <img class="col-12 col-sm-12 col-md-10 col-lg-12 col-xl-12 header-image"
             src="../assets/images/thank-you-img.png">
      </div>
      <div class="flex-wrap text-center text-box p-3" v-if="(!subscribeError)">
        <span
            class="text-content">Thank you! Your request is being processed, please look out for a confirmation SMS.</span>
      </div>
      <div class="text-center error-message-text pt-2 flex-wrap" v-if="errorMessage">
        Please complete the sign up process and try again.
      </div>
      <div class="text-center error-message-text pt-2 flex-wrap" v-if="subscribeError">
        Error occurred please try again.
      </div>
      <div class="d-flex justify-content-center" v-if="subscribeError">
        <button @click="onRetryClicked"
                class="d-flex flex-row justify-content-center align-items-center continue-button">RETRY
        </button>
      </div>
    </div>
    <div class="d-flex flex-column flex-wrap text-center terms-and-conditions pt-3">
      <div>Subscription Service.</div>
      <a href="http://play.zedgames.mobi/terms-conditions">T & C's Apply.</a>
    </div>
    <loading
        :show="showLoading"
        :label="loadingLabel">
    </loading>
  </div>
</template>

<script>
import loading from "vue-full-loading";
import {environmentConfig} from "@/config/environmentConfig";
import router from "@/router";
import {mapState, mapMutations} from "vuex";
import ZambiaIntegrationService from "@/services/zambiaIntegrationService";

export default {
  name: "LandingPage",
  data() {
    return {
      msisdn: undefined,
      showLoading: false,
      loadingLabel: "Subscribing...",
      msisdnSubmitted: false,
      subscribeError: false,
      errorMessage: false,
      currencyOne : ['K1', 'Daily'],
      currencyTwo : ['K5', 'Weekly'],
      currencyThree : ['K15', 'Monthly'],
    };
  },
  components: {
    loading
  },
  mounted() {
    this.msisdn = this.$route.query.msisdn;
  },
  computed: {
    ...mapState(['currencyAmount'])
  },
  methods: {
    ...mapMutations(['setCurrencyAmount']),
    async onJoinNowClicked(currency) {
      this.setCurrencyAmount(currency)
      if (!this?.msisdn) {
        return await router.push({path: '/wifi'});
      }

      this.toggleLoadingAnimation(true);
      const getUserResponse = await ZambiaIntegrationService.getUserViaMsisdn(this.msisdn);
      if (getUserResponse?.data?.Status === "SUBSCRIBED") {
        this.toggleLoadingAnimation();
        window.open(`${environmentConfig.zedGamesHost}/?msisdn=${this.msisdn}`, "_self");
      } else {
        await router.push({path: '/confirm-page', query: {msisdn: this?.msisdn}});
      }
    },
    toggleLoadingAnimation(toggle = false) {
      this.showLoading = toggle;
    },
    onRetryClicked() {
      this.resetScreensForRetry();
      this.onJoinNowClicked();
    },
    resetScreensForRetry() {
      this.msisdnSubmitted = false;
      this.subscribeError = false;
      this.errorMessage = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.terms-and-conditions {
  font-family: 'MTNBrighterSans', sans-serif;
  font-weight: normal;
  font-size: 12px;
}

.choose-package-text {
  font-family: 'MTNBrighterSans', sans-serif;
  font-weight: normal;
  font-size: 12px;
}

.currency-text {
  font-weight: 800;
}

</style>
